import { render, staticRenderFns } from "./ItemStock.vue?vue&type=template&id=598f4598&"
import script from "./ItemStock.vue?vue&type=script&lang=js&"
export * from "./ItemStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports